import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import generateId from './generateId';
import { updateHashProps, rewriteUserId } from '../general';
import { addDatasToSave, loadDbModel } from './workBackendSlice';
import { saveAllData, saveData, deleteData, SignUpPayload } from './dataBackend';

export type StandbyPaletteJoinedDb = {
  jointPaletteId: string;
  name: string;
  standard: boolean;
}
const initial: StandbyPaletteJoinedDb = {
  jointPaletteId: '',
  name: '',
  standard: false
};

export type StandbyPaletteJoinedDbHashType = {
  [key in string]: StandbyPaletteJoinedDb;
}

export type StandbyPaletteJoinedAddPayload = {
  id?: string;
} & StandbyPaletteJoinedDb;
export type StandbyPaletteJoinedUpdatePayload = {
  id: string;
} & { [P in keyof StandbyPaletteJoinedDb]?: StandbyPaletteJoinedDb[P] };

export type StandbyPaletteJoinedDbState = {
  standbyPaletteJoineds: StandbyPaletteJoinedDbHashType;
}

export const generateStandbyPaletteJoinedId = (): string => generateId('spj');
let initialState: StandbyPaletteJoinedDbState = { standbyPaletteJoineds: {} };
const key = 'standbyPaletteJoineds';

const standbyPaletteJoinedDbSlice = createSlice({
  name: 'standbyPaletteJoinedDb',
  initialState,
  reducers: {
    initializeStandbyPaletteJoineds(state: StandbyPaletteJoinedDbState) {
      state.standbyPaletteJoineds = {};
    },
    addStandbyPaletteJoined(state: StandbyPaletteJoinedDbState, action: PayloadAction<StandbyPaletteJoinedAddPayload>) {
      let { id, ...obj } = action.payload;
      if (!id) id = generateStandbyPaletteJoinedId();
      state.standbyPaletteJoineds[id] = obj;
      saveData(key, id, obj);
    },
    updateStandbyPaletteJoined(state: StandbyPaletteJoinedDbState, action: PayloadAction<StandbyPaletteJoinedUpdatePayload>) {
      const { id, ...obj } = action.payload;
      if (state.standbyPaletteJoineds[id] === undefined) {
        console.log(`*** StandbyPaletteJoined not found: ${id}`);
      } else {
        const newData = { ...state.standbyPaletteJoineds[id], ...obj };
        state.standbyPaletteJoineds[id] = newData;
        saveData(key, id, newData);
      }
    },
    deleteStandbyPaletteJoined(state: StandbyPaletteJoinedDbState, action: PayloadAction<StandbyPaletteJoinedUpdatePayload>) {
      const id = action.payload.id;
      delete state.standbyPaletteJoineds[id];
      deleteData(key, id);
    },
    saveStandbyPaletteJoineds(state: StandbyPaletteJoinedDbState) {
      saveAllData(key, state.standbyPaletteJoineds);
    },
    signUpStandbyPaletteJoineds(state: StandbyPaletteJoinedDbState, action: PayloadAction<SignUpPayload>) {
      const values = rewriteUserId(state.standbyPaletteJoineds, action.payload);
      addDatasToSave(key, values);
    }
  },
  extraReducers: (builder) => {
    builder.addCase(loadDbModel(key).fulfilled, (state: StandbyPaletteJoinedDbState, action) => {
      const values = action.payload;
      const [changed, updatedValues] = updateHashProps(initial, values);
      state.standbyPaletteJoineds = updatedValues;
      if (changed) saveAllData(key, state.standbyPaletteJoineds);
    })
  }
})

export const { initializeStandbyPaletteJoineds, addStandbyPaletteJoined, updateStandbyPaletteJoined, deleteStandbyPaletteJoined, saveStandbyPaletteJoineds, signUpStandbyPaletteJoineds } = standbyPaletteJoinedDbSlice.actions;
export default standbyPaletteJoinedDbSlice.reducer;
